import type { To } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import type { PermissionSelector } from "@/hooks/usePermission";
import { usePermission } from "@/hooks/usePermission";

import { Redirect } from "./Redirect";

interface RequireAuthProps {
  permission: PermissionSelector;
  children: React.ReactNode;
  redirect?: (slug: string) => To;
}

export function RequireAuth({ permission, children, redirect }: RequireAuthProps): React.ReactNode {
  const hasPermission = usePermission();

  const isPermitted = hasPermission(permission);

  if (isPermitted) {
    return children;
  }

  if (!isPermitted && redirect) {
    return <Redirect to={({ slug }) => redirect(slug)} />;
  }

  return <ErrorPage status={403} />;
}
